import ReactDOM from "react-dom/client";
import "./assets/css/App.css";
import "./assets/css/targets/targets.css";
import "./assets/css/homepage/homepage.css";
import "./assets/css/overview/overview.css";
import "./assets/css/errorOverlay/errorOverlay.css";
import "./assets/css/Sdg.css";
import "./assets/css/Pnrr.css";
import "./assets/css/Anvur.css";
import "./assets/css/template/dnd.css";
import { Box, ChakraProvider, Flex } from "@chakra-ui/react";
import theme from "./theme/theme";
import App from "App";
import { persistReducer, persistStore } from "redux-persist";
import store from "store/store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import "i18n/config";
import { BrowserRouter, RouterProvider } from "react-router-dom";
import { router } from "routes";
import Navbar from "components/navbar/Navbar";

let persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <ChakraProvider theme={theme}>
        <RouterProvider router={router} />
      </ChakraProvider>
    </PersistGate>
  </Provider>,
);
